module.exports = __webpack_public_path__ + "img/saterkommun.bfb6012f.jpg";